<template>
    <div
        class="representative-container"
        :class="representativeClass"
    >
        <p class="representative-title">
            <span>{{ $t('app.userSetting.criteriaForChoosingRepresentative') }}</span>
            <ElPopover
                v-if="showTitleTips"
                placement="top"
                :visible-arrow="false"
                width="388"
                trigger="hover"
                popper-class="user-setting__popover user-setting__popover-title-tips"
            >
                <div class="single-panel">
                    {{ $t('app.userSetting.criteriaForChoosingRepresentativeTips') }}
                </div>
                <PtIcon
                    slot="reference"
                    icon="SolidInfo"
                    style="font-size: 24px; fill: #B3BAC5;"
                    class="hover-icon"
                />
            </ElPopover>
        </p>
        <div class="representative-item clearfix">
            <RepresentativeItem
                :model-type="modelType"
                :service-area="serviceArea"
                :group-data="firstRuleData"
                @updateData="updateFirstRuleData"
            />
            <ElTooltip
                v-if="showAddBtn"
                placement="top"
                popper-class="representative__add-rule-tooltip"
                :visible-arrow="false"
                :content="$t('app.userSetting.AddRule')"
            >
                <span
                    class="rule-btn"
                    @click="showSecondRule = true"
                >
                    <PtIcon
                        icon="SolidAddLarge"
                        style="font-size: 24px; fill: #505F79;"
                    />
                </span>
            </ElTooltip>
        </div>
        <div
            v-if="multipleRule && modelType !== 'APNO_FACET'"
            class="representative-item clearfix"
        >
            <span class="representative-item-left">{{ $t('app.userSetting.secondRule') }}</span>
            <RepresentativeItem
                :model-type="modelType"
                :group-data="secondRuleData"
                :service-area="serviceArea"
                :exclude-field="firstRuleData.groupBy"
                @updateData="updateSecondRuleData"
            />
            <ElTooltip
                placement="top"
                popper-class="representative__add-rule-tooltip"
                :visible-arrow="false"
                :content="$t('app.userSetting.RemoveRule')"
            >
                <span
                    class="rule-btn"
                    @click="removeRule"
                >
                    <PtIcon
                        icon="SolidDelete"
                        style="font-size: 24px; fill: #505F79;"
                    />
                </span>
            </ElTooltip>
        </div>
    </div>
</template>
<script>
import Tooltip from 'element-ui/lib/tooltip';
import Popover from 'element-ui/lib/popover';
import PtIcon from '@patsnap-biz/icon';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

import { ruleToGroupData, groupDataToRule } from './settingConfig';
import RepresentativeItem from './RepresentativeItem.vue';

export default {
    components: {
        RepresentativeItem,
        PtIcon,
        ElTooltip: Tooltip,
        ElPopover: Popover,
    },
    props: {
        modelType: {
            type: String,
            default: '',
        },
        collapse: {
            type: Object,
            default: () => {},
        },
        renderType: {
            type: String,
            default: '',
        },
        serviceArea: {
            type: String,
            default: 'cn',
        },
        showTitleTips: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            firstRuleData: {},
            secondRuleData: {},
            showSecondRule: false,
        };
    },
    computed: {
        showAddBtn() {
            return this.firstRuleData.groupBy !== 'SCORE'
            && this.modelType !== 'APNO_FACET'
            && !this.secondRuleData.groupBy;
        },
        multipleRule() {
            return this.showSecondRule || this.secondRuleData.groupBy;
        },
        hasAuthority() {
            return (this.firstRuleData.groupBy === 'AUTHORITY' || this.secondRuleData.groupBy === 'AUTHORITY')
            && (this.modelType !== 'APNO_FACET' && this.modelType !== 'ALL');
        },
        representativeClass() {
            const classes = [];
            if (this.renderType === 'quickSetting') {
                classes.push('quick-setting');
            }
            if (this.multipleRule) {
                classes.push('multiple-rule');
            }
            if (this.hasAuthority) {
                classes.push('has-authority');
            }
            return classes;
        },
        groupBy() {
            return this.firstRuleData.groupBy;
        },
    },
    watch: {
        groupBy() {
            // 第一规则为最相关，或者第一规则和第二规则相同时，删除第二规则
            this.resetSecondRule();
        },
        modelType() {
            this.collapseToValue();
        },
    },
    mounted() {
        this.valueToCollapse();
    },
    created() {
        this.collapseToValue();
    },
    methods: {
        updateFirstRuleData(data) {
            this.firstRuleData = data;
            this.valueToCollapse();
        },
        updateSecondRuleData(data) {
            this.secondRuleData = data;
            this.valueToCollapse();
        },
        collapseToValue() {
            const { field, rules = [] } = this.collapse;
            if (field) {
                this.firstRuleData = ruleToGroupData(rules[0]);
                if (field !== 'APNO_FACET') {
                    this.secondRuleData = ruleToGroupData(rules[1]);
                }
            }
        },
        valueToCollapse() {
            const rules = [];
            if (!isEmpty(this.firstRuleData)) {
                rules.push(groupDataToRule(this.firstRuleData));
            }
            if (!isEmpty(this.secondRuleData)) {
                rules.push(groupDataToRule(this.secondRuleData));
            }
            const collapse = {
                field: this.modelType,
                rules,
            };
            this.$emit('updateCollapse', collapse);
        },
        removeRule() {
            this.secondRuleData = {};
            this.valueToCollapse();
            this.showSecondRule = false;
        },
        resetSecondRule() {
            const firstGroupBy = get(this.firstRuleData, 'groupBy');
            const secondGroupBy = get(this.secondRuleData, 'groupBy');
            if (firstGroupBy === 'SCORE' || firstGroupBy === secondGroupBy) {
                this.removeRule();
            }
        },
    },
};
</script>
